// extracted by mini-css-extract-plugin
export default {"text":"CookieBanner-module__text-Gk5c","banner":"CookieBanner-module__banner-Ijkh","actions":"CookieBanner-module__actions-cMtj"};